import { useQueryClient } from "@tanstack/react-query";

import { ServerError } from "src/graphql-next/fetcher";
import { useGetMeQuery as useGetMeQueryOnNewGateway } from "src/graphql-next/generated/queries";
import { GetMeQuery as GetMeQueryOnNewGateway } from "src/graphql-next/generated/types";
import { GetMeQuery } from "src/graphql/generated/types";
import { getCustomerDisplayNameFromGatewayNext } from "src/utils/customer/getCustomerDisplayName";

export type Me = {
  login: string;
  isTemporary: boolean;
  fullname: string | undefined;
};

export type UseGetMeResult = {
  data: { me: Me } | undefined;
  isLoading: boolean;
  error: ServerError | null;
};

export type UseGetMeQueryDataResult = {
  data: { me: Me } | undefined;
};

export const useGetMe = (): UseGetMeResult => {
  const { data: dataOnNewGateway, ...queryResultOnNewGateway } = useGetMeQueryOnNewGateway();

  return {
    data: dataOnNewGateway && { me: mapMe(dataOnNewGateway.me) },
    ...queryResultOnNewGateway,
  };
};

export const useGetMeQueryData = (): UseGetMeQueryDataResult => {
  const queryClient = useQueryClient();

  const queryDataOnNewGateway = queryClient.getQueryData<GetMeQueryOnNewGateway>(
    useGetMeQueryOnNewGateway.getKey()
  );

  return {
    data: queryDataOnNewGateway && { me: mapMe(queryDataOnNewGateway.me) },
  };
};

function mapMe(me: GetMeQuery["me"] | GetMeQueryOnNewGateway["me"]): Me {
  if (me.__typename === "Me") {
    return {
      login: me.login,
      isTemporary: me.isTemporary,
      fullname: me.fullname ?? undefined,
    };
  }

  return {
    login: me.login,
    isTemporary: me.isTemporaryLogin,
    fullname: getCustomerDisplayNameFromGatewayNext(me.customer) ?? undefined,
  };
}
